var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`chip ${_vm.active ? 'active' : 'non-active'}`},[_vm._v(_vm._s(_vm.active ? 'Aktif' : 'Tidak Aktif'))])
}
var staticRenderFns = []

export { render, staticRenderFns }